<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 unnumbered" id="section" style="padding-left:50px">
<h1 class="unnumbered"></h1>
<div class="section level3" id="about-the-author">
<h1 style="padding-top:200px; width:550px;">About the Author</h1>
<p style="width:550px; text-indent:0px; font-size:10pt;font-family:calibri;">Dirk Bolt was born in the Netherlands. As a student he migrated to Australia, where he became an award-winning architect in Hobart and Canberra. When, as an urban planner, he became concerned about urbanisation, the environment, climate change and sustainability, he started to work for the UN and in interna- tional development. He taught at the University of Auckland, and was appointed professor in the Netherlands. He worked and travelled with his family in Australia, Africa, Asia, the Pacific and Europe; he now lives with his wife Kusha in Scotland.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?2688134d